import { FC, useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import CustomLabel from "./CustomLabel";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";

interface CustomAutocompleteProps {
  id: string;
  label: string;
  options: Array<any>;
  loading?: boolean;
  disabled?: boolean;
  getOptionLabel: (option: any) => string;
  getOptionKey: (option: any) => string;
  defaultValue?: any; // Ajout de la prop defaultValue
  [key: string]: any;
  value: any;
  onChange: (newValue: any) => void;
}

const CustomAutocomplete: FC<CustomAutocompleteProps> = ({
  id,
  label,
  loading,
  disabled,
  options,
  getOptionLabel,
  getOptionKey,
  defaultValue,
  value,
  onChange,
  ...props
}) => {
  useEffect(() => {
    onChange(defaultValue);
  }, [defaultValue, onChange]);

  return (
    <>
      <CustomLabel label={label} />
      <Autocomplete
        id={id}
        loading={loading}
        disabled={disabled}
        disablePortal
        disableClearable
        sx={{
          py: 1,
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#F1F1F2",
            "& fieldset": {
              borderColor: "#E8EBFD",
            },
          },
        }}
        options={options}
        getOptionLabel={getOptionLabel}
        getOptionKey={getOptionKey}
        value={value || defaultValue || null}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        renderInput={(params) => <TextField {...params} />}
        popupIcon={<KeyboardArrowDownOutlinedIcon />}
        noOptionsText="Aucune option"
        {...props}
      />
    </>
  );
};

export default CustomAutocomplete;
